import React from 'react';
import close from "../../../images/close.svg";
import {connect} from "react-redux";
import FileDocViewer from 'react-file-viewer';


const FileViewer = ({closeModal, isDark, currentCrewFile}) => {
  return (
    <div style={{width: 1082, height: '90vh'}} className={`modal ${isDark && 'modal__dark'}`}>
      <button onClick={closeModal} className="modal__close">
        <img src={close} alt=""/>
      </button>
      <div style={{maxHeight: '93%'}} className="modal__sections mr-24 mt-24">
          <FileDocViewer filePath={currentCrewFile.base64} fileType={currentCrewFile.fileType} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentCrewFile: state.logbookReducer.currentCrewFile
})

export default connect(mapStateToProps, {})(FileViewer)
